<script setup lang="ts">
import type { AppDownloadLinksResponse } from '~/api/download'
import type { FeedbackDetailData } from '~/api/feedback'

type FeedbackRankItem = {
  name?: string
  icon?: string
  code?: string
  alias?: string
}

const props = defineProps<{
  feedbackDetailData?: FeedbackDetailData | null
  downloadLinks?: AppDownloadLinksResponse
}>()

const { t, localePath } = useAppI18n()

const route = useRoute()
const { setBreadcrumb } = useLsBreadcrumb()

/** 点击跳转交易商排行详情前，缓存当前页面为来源面包屑 */
const handleExchangeRankingClick = (item: FeedbackRankItem) => {
  setBreadcrumb(item.alias, {
    labelKey: '84077',
    route: route.fullPath,
  })
}

const rankList = computed(() => {
  const detailData = props.feedbackDetailData
  if (detailData?.weekRankings && detailData.weekRankings.length > 0) {
    return detailData.weekRankings
  }
  return detailData?.totalRankings ?? []
})
</script>

<template>
  <div class="flex w-full shrink-0 flex-col space-y-[24px] bg-[#F5F6F8] min-[1248px]:w-[384px]">
    <div
      v-if="rankList && rankList.length > 0"
      class="flex flex-col space-y-[12px] rounded-[12px] border border-[rgba(5,21,36,0.06)] bg-[#FFF] px-[24px] pt-[8px] pb-[16px]"
    >
      <div class="w-full border-b-[0.5px] border-[rgba(5,21,36,0.06)]">
        <div class="flex items-center py-[16px]">
          <div class="text-[20px] leading-[28px] font-[600] text-[#292a2e]">
            {{
              props.feedbackDetailData?.weekRankings && props.feedbackDetailData.weekRankings.length > 0
                ? t('83859')
                : t('84607')
            }}
          </div>
        </div>
      </div>
      <div
        class="flex w-full overflow-hidden max-[1247px]:space-x-[12px] max-[1247px]:overflow-x-auto max-[1247px]:overflow-y-hidden min-[1248px]:flex-col"
      >
        <NuxtLink
          v-for="(item, index) in rankList"
          :key="`${item.name}-${index}`"
          :to="localePath(item.alias ? `/exchanges/${item.alias}` : '/')"
          target="_blank"
          class="flex shrink-0 cursor-pointer items-center space-x-[8px] overflow-hidden rounded-[8px] px-[-8px] py-[12px] transition-colors duration-200 hover:bg-[#f8f8f8] max-[1247px]:pr-2 min-[1248px]:w-full rtl:pr-0 rtl:max-[1247px]:pl-2"
          @click="handleExchangeRankingClick(item)"
        >
          <div
            class="w-[20px] shrink-0 text-center text-[14px] leading-[22px] font-[400] whitespace-nowrap"
            :class="Number(index) < 3 ? 'text-[#292a2e]' : 'text-[#b7b9be]'"
          >
            {{ Number(index) + 1 }}
          </div>
          <CommonImage class="h-[20px] w-[20px] shrink-0 rounded-[2px] object-cover" :src="item.icon" />
          <div class="min-w-0 truncate text-[16px] leading-[24px] font-[400] whitespace-nowrap text-[#292a2e]">
            {{ item.name }}
          </div>
        </NuxtLink>
      </div>
    </div>
    <CommonDownload
      class="flex flex-col space-y-[24px] overflow-hidden rounded-[12px] bg-[#e9f2ff] p-[24px] max-[1247px]:hidden"
      :download-links="props.downloadLinks"
    />
  </div>
</template>
